import { Component, inject } from "@angular/core";
import { LoaderService } from "../../services/loader/loader.service";

@Component({
  selector: "feui-loader", templateUrl: "./loader.component.html", styleUrls: ["./loader.component.scss"]
})
export class LoaderComponent {
  loader: LoaderService = inject(LoaderService);
}
